import { AgeRoleplayOptionsType } from './types';

export const AGE_ROLEPLAY_OPTIONS: AgeRoleplayOptionsType = [
  {
    id: 'young',
    title: 'Young',
  },
  {
    id: 'experienced',
    title: 'Experienced',
  },
];
